export default __webpack_public_path__ + "static/media/info-bg.a3f21311.png";